/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cool_Noisy_Hyena_EmbraceInputs */

const es_cool_noisy_hyena_embrace = /** @type {(inputs: Cool_Noisy_Hyena_EmbraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscribiendo...`)
};

const gl_cool_noisy_hyena_embrace = /** @type {(inputs: Cool_Noisy_Hyena_EmbraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribíndose...`)
};

const en_cool_noisy_hyena_embrace = /** @type {(inputs: Cool_Noisy_Hyena_EmbraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribing...`)
};

/**
* | output |
* | --- |
* | "Subscribing..." |
*
* @param {Cool_Noisy_Hyena_EmbraceInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cool_noisy_hyena_embrace = /** @type {((inputs?: Cool_Noisy_Hyena_EmbraceInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Noisy_Hyena_EmbraceInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cool_noisy_hyena_embrace(inputs)
	if (locale === "en") return en_cool_noisy_hyena_embrace(inputs)
	return es_cool_noisy_hyena_embrace(inputs)
});